import { isProductEnabled } from "@/business/product-access";
import { useGetQuickbooksConnection } from "@/business/quickbooks-query";
import { useBusiness } from "@/core/business";
import { useBusinessProducts } from "@/core/business/use-business-products";
import { useGetMyUser } from "@/user/query";
import { canManageFinances } from "@/user/utils";

/**
 * Who sees the QuickBooks UI in AP, matching the profile dropdown entry: AP
 * enabled and ServiceTitan on. Anyone may see the state; those who may manage
 * the business's finances, as the API decides, act on it.
 */
export const useQuickbooksAccess = () => {
  const { businessId, selectedBusiness } = useBusiness();
  const { settings } = useBusinessProducts();
  const { data: user } = useGetMyUser();

  return {
    businessId,
    isVisible:
      isProductEnabled(settings, "accounts_payable") &&
      !!selectedBusiness?.service_titan_enabled,
    canManage: canManageFinances(user),
    isUserLoaded: !!user,
  };
};

/**
 * Whether the AP sidebar lists the QuickBooks view, and whether to flag it.
 * Those who can manage always see it, so they can connect; others only once
 * there is a connection to look at.
 */
export const useQuickbooksNavState = () => {
  const { businessId, isVisible, canManage } = useQuickbooksAccess();
  const { data: connection } = useGetQuickbooksConnection(businessId, {
    enabled: isVisible,
  });
  const status = connection?.status;

  return {
    isListed:
      isVisible &&
      (canManage || status === "connected" || status === "needs_reconnect"),
    needsReconnect: isVisible && status === "needs_reconnect",
  };
};
